import { useNavigate, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getCliente } from '@/api/clientes';
import { Header } from '@/components/Header';
import { Card } from '@/components/Card';
import { StatusTag } from '@/components/StatusTag';
import styles from './pages.module.css';

export function ClientePage() {
  const { clienteSlug } = useParams<{ clienteSlug: string }>();
  const navigate = useNavigate();
  const { data, isLoading, error } = useQuery({
    queryKey: ['cliente', clienteSlug],
    queryFn: () => getCliente(clienteSlug!),
    enabled: !!clienteSlug,
  });

  if (isLoading) {
    return (
      <>
        <Header breadcrumbs={[{ label: 'Inicio', to: '/' }, { label: '…' }]} title="Cargando…" />
        <div className={`container ${styles.body}`}>
          <div className="empty">Cargando…</div>
        </div>
      </>
    );
  }
  if (error || !data) {
    return (
      <>
        <Header breadcrumbs={[{ label: 'Inicio', to: '/' }]} title="No encontrado" />
        <div className={`container ${styles.body}`}>
          <div className="empty">Cliente no encontrado.</div>
        </div>
      </>
    );
  }

  const facilities = data.facilities || [];
  const activas = facilities.filter((f) => f.status === 'activa').length;

  return (
    <>
      <Header
        breadcrumbs={[{ label: 'Inicio', to: '/' }, { label: data.nombre }]}
        title={
          <>
            {data.nombre}
            <span className={styles.industriaPill} style={{ background: data.color }}>
              {data.industria}
            </span>
          </>
        }
        subtitle="Instalaciones / Plantas con propuestas adjudicadas o en proceso."
        meta={
          <>
            <span>{facilities.length} instalaciones</span>
            <span>{activas} con propuesta cargada</span>
          </>
        }
      />

      <div className={`container ${styles.body}`}>
        {facilities.length === 0 ? (
          <div className="placeholder-wrap">
            <div className="icon">📂</div>
            <h3>Aún no hay instalaciones cargadas para {data.nombre}</h3>
            <p>
              Cuando me compartas las propuestas adjudicadas, las agrego aquí con su checklist y
              blueprint NIDA.
            </p>
          </div>
        ) : (
          <div className={styles.grid}>
            {facilities.map((f) => (
              <Card
                key={f.id}
                bannerColor={data.color}
                icon="🏭"
                title={f.nombre}
                subtitle={f.subtitulo}
                progressBars={f.progress}
                health={f.progress?.health}
                footer={
                  <>
                    <StatusTag status={f.status} />
                    <span className={styles.arrow}>
                      {f.status === 'activa' ? 'Ver detalle →' : 'Abrir →'}
                    </span>
                  </>
                }
                onClick={() => navigate(`/clientes/${data.slug}/${f.slug}`)}
              />
            ))}
          </div>
        )}
      </div>
    </>
  );
}
